import { useCallback, useEffect, useState } from "react";
import axios from "axios";

const API_BASE = process.env.REACT_APP_BACKEND_URL || "";

function toFormData(payload, file) {
    const fd = new FormData();
    Object.entries(payload || {}).forEach(([key, value]) => {
        if (value === undefined) return;
        fd.append(key, value === null ? "" : String(value));
    });
    if (file) fd.append("image", file);
    return fd;
}

export default function useLogos() {
    const [logos, setLogos] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const fetchLogos = useCallback(async () => {
        setLoading(true);
        setError("");
        try {
            const res = await axios.get(`${API_BASE}/api/logos`, { withCredentials: true });
            setLogos(res.data || []);
        } catch (e) {
            setError(e?.response?.data?.error || e.message);
        } finally {
            setLoading(false);
        }
    }, []);

    const createLogo = useCallback(async (payload, file = null) => {
        const hasFile = !!file;
        const res = hasFile
            ? await axios.post(`${API_BASE}/api/logos`, toFormData(payload, file), {
                withCredentials: true,
                headers: { "Content-Type": "multipart/form-data" },
            })
            : await axios.post(`${API_BASE}/api/logos`, payload, { withCredentials: true });
        await fetchLogos();
        return res.data?.logo;
    }, [fetchLogos]);

    const updateLogo = useCallback(async (id, payload, file = null) => {
        const hasFile = !!file;
        const res = hasFile
            ? await axios.put(`${API_BASE}/api/logos/${id}`, toFormData(payload, file), {
                withCredentials: true,
                headers: { "Content-Type": "multipart/form-data" },
            })
            : await axios.put(`${API_BASE}/api/logos/${id}`, payload, { withCredentials: true });
        await fetchLogos();
        return res.data?.logo;
    }, [fetchLogos]);

    const deleteLogo = useCallback(async (id) => {
        await axios.delete(`${API_BASE}/api/logos/${id}`, { withCredentials: true });
        await fetchLogos();
    }, [fetchLogos]);

    useEffect(() => {
        fetchLogos();
    }, [fetchLogos]);

    return {
        logos,
        loading,
        error,
        fetchLogos,
        createLogo,
        updateLogo,
        deleteLogo,
    };
}
